import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useTranslation } from "react-i18next";
import { useGetCompanyUsers } from "../../../../../../api/DocumentApi";
import CustomSelect from "../../../../../../components/FormComponents/CustomSelect";
import CustomTextInput from "../../../../../../components/FormComponents/CustomTextInput";
import When from "../../../../../../components/When";
import { getDataRowHeader } from "../../../../../../core/helpers/dataRowHelper";
import { IDataRowProps, IUserDataRow } from "../../../../../../core/interfaces/document";
import DataRowActionButtons from "./DataRowActionButtons";


const UserDataRow = (
    {
        dataRow,
        setDataRow,
        isHeaderEnabled,
        isFieldEnabled,
        removeDataRow,
        copyDataRow,
        checklistViewTable,
        isEditMode,
        isAnswerMode = false,
        isActive,
        requiredSubType
    }: IDataRowProps<IUserDataRow>) => {

    const {t} = useTranslation();
    const [users] = useGetCompanyUsers();

    const onChangeValue = (e: any) => {
        const value = (e.target.value ?? "");
        setDataRow({
            ...dataRow,
            [e.target.name]: value.length > 0 ? value : undefined
        });
    }
    return <>
        <Row className={checklistViewTable ? "" : "mt-3 mb-3 ms-2 me-2"}>
            <When condition={!checklistViewTable}>
                <Col md={3}>
                    <CustomTextInput
                        isEditMode={isEditMode}
                        disabled={!isHeaderEnabled}
                        name={"header"}
                        placeholder={t('UserDataRow.FOR_EXAMPLE_EMPLOYEES_1')}
                        value={getDataRowHeader(dataRow)}
                        onChange={onChangeValue}
                        disableAutocomplete
                    />
                </Col>
            </When>
            <Col md={
                isEditMode && isActive
                    ? checklistViewTable ? 12 : 7
                    : checklistViewTable ? 12 : 9
            }>
                <CustomSelect
                    checklistViewTable={checklistViewTable}
                    required={requiredSubType.includes(dataRow.subType!)}
                    disabled={!isFieldEnabled || !(isAnswerMode || isEditMode)}
                    isEditMode={true}
                    name={"userId"}
                    value={dataRow.userId ?? '-'}
                    onChange={onChangeValue}
                    options={<>
                        <option key={''} value={''}>{t('UserDataRow.SELECT_EMPLOYEE_1')}</option>
                        {users.map(person => <option key={person.userId} value={person.userId}>{person.name}</option>)}
                    </>}
                />
            </Col>

            <When condition={isEditMode && isActive}>
                <DataRowActionButtons
                    dataRow={dataRow}
                    removeDataRow={removeDataRow}
                    copyDataRow={copyDataRow}
                />
            </When>
        </Row>

    </>
};



export default UserDataRow;
